import React from 'react'

import {AiOutlineLoading} from 'react-icons/ai'
import { LoaderContainer } from './styles'

export function Loading(){
  return (
    <LoaderContainer>
      <AiOutlineLoading size={48} color="#3699FF"/>
      <span>Carregando...</span>
    </LoaderContainer>
  )
}